import { ModuleListItem } from '../interfaces/Organization';
import { MCurrentVersion } from './current-version.model';

export class MModuleListItem{
    public id: number;
    public name: string;
    public isPublic: boolean;
    public allowed: boolean;
    public versions: MCurrentVersion[] = [];
    public description: string;

    constructor(item: ModuleListItem, asignado: boolean = true){
        this.id = item.id;
        this.name = item.nombre;
        this.isPublic = item.publico;
        this.allowed = asignado;
        this.description = item.descripcion;
        for (let i = 0; i < item.versiones_modulos.length; i++) {
            this.versions.push(new MCurrentVersion(item.versiones_modulos[i]));
        }
    }
}